'use client';

import { useEffect, useRef } from 'react';

import { useIntersectionObserver } from '@monoimin/hooks';
import { Analytics } from '@monoimin/utils/analytics';

import { trackAmplitudeEvent } from '../../amplitude/amplitude';

import type { C2AAnalyticsClientProps } from '@monoimin/sb-types';

const CTA_VIEW_EVENT_NAME = 'CTA Block View';
const EXTRA_SERVICE_EVENT_NAME = 'Extra Services Block View';

const eventNameByComponent = {
  c2a: { renta: CTA_VIEW_EVENT_NAME, gtm: CTA_VIEW_EVENT_NAME },
  'extra-services': {
    renta: EXTRA_SERVICE_EVENT_NAME,
    gtm: EXTRA_SERVICE_EVENT_NAME,
  },
} as const;

export type TrackBlockImpressionProps = C2AAnalyticsClientProps & {
  className?: string;
  component_type: 'c2a' | 'extra-services';
};

export const TrackBlockImpression = (data: TrackBlockImpressionProps) => {
  const wrapperRef = useRef(null);

  const entry = useIntersectionObserver(wrapperRef, {
    threshold: 0,
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (entry?.isIntersecting && typeof window !== 'undefined') {
      const renta = new Analytics();

      const currentUrl = window.location.href;

      const componentType = data.component_type;
      const eventNames = eventNameByComponent[componentType];

      const _data = { ...data, component_type: undefined };
      delete _data.className;
      delete _data.component_type;

      let trackData = {};

      if (eventNames.renta === CTA_VIEW_EVENT_NAME) {
        trackData = {
          ..._data,
          page_url: currentUrl,
          event_type: 'view',
        };
      } else {
        trackData = {
          ..._data,
          page_url: currentUrl,
          language: data.language,
          block_action: 'impression',
        };
      }
      renta.track(eventNames.renta, trackData);

      trackAmplitudeEvent({
        deviceId: '',
        userId: null,
        name: eventNames.renta,
        properties: trackData,
      });
    }
  }, [entry?.isIntersecting]);

  return (
    <div
      ref={wrapperRef}
      className={`${data.component_type} analytics absolute`}
    />
  );
};
